import { render, staticRenderFns } from "./Vision.vue?vue&type=template&id=b83dfba8"
import script from "./Vision.vue?vue&type=script&lang=js"
export * from "./Vision.vue?vue&type=script&lang=js"
import style0 from "./Vision.vue?vue&type=style&index=0&id=b83dfba8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports